import axios from "axios";
import getApiDomain from "@/api/getApiDomain";

export interface AdyenOnboardingStatus {
  id: number;
  status: string;
  onboarding_url: string | null;
  legal_entity_id: string | null;
  created: string;
}

export async function getAdyenOnboardingStatus(): Promise<AdyenOnboardingStatus | null> {
  const token = window.localStorage.getItem("auth_token");
  if (!token) return null;

  try {
    const response = await axios.get(getApiDomain() + "/api/adyen-notification", {
      headers: {
        "X-HTTP-AUTHORIZATION": "Authenticate " + token,
      },
    });
    return response.data?.data ?? null;
  } catch {
    return null;
  }
}

export async function createAdyenTransactionsSession(): Promise<{ id: string; token: string } | null> {
  const token = window.localStorage.getItem("auth_token");
  if (!token) return null;

  try {
    const response = await axios.post(
      getApiDomain() + "/api/adyen-session",
      { allow_origin: window.location.origin },
      {
        headers: {
          "X-HTTP-AUTHORIZATION": "Authenticate " + token,
        },
      }
    );
    return response.data?.data ?? null;
  } catch {
    return null;
  }
}

export async function respondToOnboarding(
  adyenCustomerId: number,
  action: "accept" | "decline"
): Promise<{ success: boolean; onboarding_url?: string }> {
  const token = window.localStorage.getItem("auth_token");

  const response = await axios.put(
    getApiDomain() + "/api/adyen-notification/" + adyenCustomerId,
    { action },
    {
      headers: {
        "X-HTTP-AUTHORIZATION": "Authenticate " + token,
      },
    }
  );
  return response.data;
}
